export default __webpack_public_path__ + "static/media/qr-code.9755b1f0.png";